import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../../customComponents/CustomTable';
import editIcon from './../../../../../../Assets/icons/Un-Checkbox.svg'; 
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../../services/api/API'; 
import ROUTES_NAVIGATION from '../../../../../../routes/routes';
import SearchInput from '../../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../../customComponents/CustomLoader';

const BusinessPartnerTypeList = () => {
  const [businessPartnerTypes, setBusinessPartnerTypes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [ city, setCity ] = useState([])
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(true);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)
  const [ revenue, setRevenue ] = useState(0)

  useEffect(() => {
    fetchBusinessPartnerTypes();
    fetchCity();
  }, []);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchBusinessPartnerTypes(newPage);
  };

  const fetchCity = async () => {
    try {
      const response = await axiosInstance.get("/pincodestatecity/cityList", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data.data; 
      const cityOptions = data.map(city => ({
        value: city.city_id,
        label: city.city_name,
      }));
      setCity(cityOptions); // Assuming setCity is a state setter function
    } catch (error) {
      console.log(error); // Log the error for debugging purposes
    }
  };

  const fetchBusinessPartnerTypes = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/businesspartnertype/list', {
        orderBy: 'business_partner_type_id desc',
        page,
        pageSize,
        searchText:searchTerm

      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response.data.data.data.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  
      }));

      const totalRecordsData = response?.data?.data?.totalRecords

      const totalCount = response?.data?.data?.total
      const totalRevenue = response?.data?.data?.total_revenue
      const unitSold = response?.data?.data?.unit_sold
      const revenueCount = response?.data?.data?.annual_revenue

      setTotalData(totalCount)
      setTotalActive(totalRevenue)
      setTotalInactive(unitSold)
      setRevenue(revenueCount)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setBusinessPartnerTypes(formattedData); 
      // toastSuccess("Data fetched successfully!"); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error('Error fetching business partner types:', error);
    }
    finally{
      setLoading(false)
    }
  };

  // Table headers
  const BUSINESS_PARTNER_TYPE_TABLE_HEADERS = [
    // "Sr No.",
    // "Business Partner Type ID",
    "Name",
    "Description",
    "Status",
    "Action"
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_TYPE_KEY_MAPPING = {
    // "Sr No.": "Sr No.",
    // "Business Partner Type ID": "business_partner_type_id",
    "Name": "business_partner_type_name",
    "Description": "business_partner_type_desc",
    "Status": "status",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
    ]
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITBUSINESPARTNERTYPE}`, { state: { data: rowData } });
    // console.log("rowdata", rowData)
  }
  useEffect(() => {
    if (searchTerm === "") {
      fetchBusinessPartnerTypes();
    }
  }, [searchTerm]);

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer row'>
        <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>Business Partner Type Management</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
        <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText" >{totalData} </h5>
            <h6>All Business Partner Type</h6>
          </div>
          <div  className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}}>
            <h5 className="listTopDataValueText" >{totalInactive} </h5>
            <h6>Unit Sold</h6>
          </div>
          <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}}>
            <h5 className="listTopDataValueText" >{totalActive} </h5>
            <h6>Revenue</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText" >{revenue} </h5>
            <h6>Annual Revenue</h6>
          </div>
          <div>
            <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-dealer/business-partner-type/add-business-partner-type')}>
              Add Business Partner Type
            </button>
          </div>
        </div>
      </div>

      {/* <ListFilters city={city} clearSearch={clearFilter} handleSearch={handleSearch} /> */}

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>Business Partner Types List</h5>
            <div>
              <SearchInput
                placeholder="Search Business Partner"
                onSearch={fetchBusinessPartnerTypes}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
         
        </div>

        <CustomTable data={businessPartnerTypes} headers={BUSINESS_PARTNER_TYPE_TABLE_HEADERS} keyMapping={BUSINESS_PARTNER_TYPE_KEY_MAPPING} itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit} 
          totalRecords={totalRecords} 
          />
      </div>
    </div>
     )}
  </div>
  );
};

export default BusinessPartnerTypeList;
